import PropTypes from 'prop-types';
import React from 'react';
import Avatar from 'react-avatar';
import { Button, Image } from 'react-bootstrap';
import { browserHistory } from 'react-router';
import Rating from "react-rating";

function makeInitials(name) {
  const splits = name.split(' ');
  if (splits.length > 1) return splits.slice(0, 2).join(' ');
  return name;
}

class HotelCard extends React.Component {
  onView = () => {
    this.props.viewHotel(this.props.hotel.id);
  };

  onClick = () => {
    if (this.props.managed) {
      this.props.viewHotel(this.props.hotel.id);
    } else {
      this.props.requestHotelClaim(this.props.hotel.id);
    }
  };

  onUserClick = () => {
    browserHistory.push(`/hotels/users/${this.props.hotel.id}`);
  };
  report = () => {
    browserHistory.push(`/feedback/hotel/${this.props.hotel.id}`);
  };
  render() {
    let image = (
      <a onClick={this.onView}>
        <Avatar
          name={makeInitials(this.props.hotel.name)}
          color="#326a34"
          size={250}
          maxInitials={2}
          onClick={this.onView}
        />
      </a>
    );
    if (this.props.hotel.image) {
      image = <Image src={this.props.hotel.image} responsive onClick={this.onView} />;
    }
    let toolbar = (
      <div className="hotel-edit-button">
        <Button onClick={this.onClick} bsStyle="success">
          Claim
        </Button>
        <Button onClick={this.report}>Report</Button>
      </div>
    );
    if (this.props.managed) {
      const label = this.props.readOnly ? 'View' : 'Edit';
      toolbar = (
        <div className="hotel-edit-button">
          <Button onClick={this.onClick} bsStyle="success">
            {label}
          </Button>
          <Button onClick={this.onUserClick} bsStyle="success">
            Users
          </Button>
        </div>
      );
    }

    return (
      <div className="col-sm-6 col-md-6 tour-container">
        <div className="tour">
          <div className="tour-image">{image}</div>
          <div className="tour-name">
           {this.props.isSearchHotel && this.props.hotel.is_subscriber_hotel ? 
            (
              <div style={{color: 'green'}}>
                <h3>{this.props.hotel.name}</h3>
                <p>
                  {this.props.hotel.address}, {this.props.hotel.locality}, {this.props.hotel.region}
                </p>
              </div>
            ) : 
            (
              <div>
                <h3>{this.props.hotel.name}</h3>
                <p>
                  {this.props.hotel.address}, {this.props.hotel.locality}, {this.props.hotel.region}
                </p>
              </div>
            )}
            <p>
              {this.props.isSearchHotel && this.props.hotel.is_subscriber_hotel ?
                (<span style={{color: 'green'}}>{this.props.hotel.stars}</span>) : (<span>{this.props.hotel.stars}</span>)}
              <Rating readonly initialRating={this.props.hotel.stars}
                emptySymbol={'fa fa-star-o rating-color'}
                fullSymbol={'fa fa-star rating-color'}
              />
            </p>
          </div>
          {toolbar}
        </div>
      </div>
    );
  }
}
HotelCard.propTypes = {
  managed: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  hotel: PropTypes.object.isRequired,
  viewHotel: PropTypes.func.isRequired,
  requestHotelClaim: PropTypes.func.isRequired,
};
export default HotelCard;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelCard.js